import { useEffect, useState } from 'react';

function computeSecondsLeft(resendAvailableAt: number | undefined): number {
  if (!resendAvailableAt) return 0;
  return Math.max(0, Math.ceil((resendAvailableAt - Date.now()) / 1000));
}

export function useResendCooldown(resendAvailableAt: number | undefined): number {
  const [, forceTick] = useState<number>(0);
  const secondsLeft = computeSecondsLeft(resendAvailableAt);

  useEffect(() => {
    if (!resendAvailableAt || computeSecondsLeft(resendAvailableAt) <= 0) return;

    const interval = setInterval(() => {
      forceTick((tick) => tick + 1);
      if (computeSecondsLeft(resendAvailableAt) <= 0) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [resendAvailableAt]);

  return secondsLeft;
}
